import PropTypes from 'prop-types'

const ResetUserHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

ResetUserHeader.defaultProps = {
    title: 'Reset User Account',
}

ResetUserHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default ResetUserHeader
